import { ethers } from 'ethers'

export type SignatureParams = {
    paymentAmountMax: string
    startTime: number
    paymentToken: string
    cadence: number
    subscriptionType: number
    totalPayments: number
    paymentReference: string
}

export const roundNumber = (num: number) => Math.round((num + Number.EPSILON) * 100) / 100
export const formatPaymentReference = (paymentId: string) => {
    return ethers.utils.hexZeroPad(ethers.utils.arrayify(`0x${paymentId}`), 32)
}

export const fiatAmountToTokenInputMax = (amount: number, tokenDecimals: number) => {
    let fee = roundNumber(amount * 0.02)
    if (fee === 0) fee = 0.01

    const usdPaymentAmount = roundNumber(amount + fee).toString()
    return ethers.utils.parseUnits(usdPaymentAmount, tokenDecimals).toString()
}
